import { useCarousel } from '@/common/hooks/useCarousel';
import { generateUrlFromContainerWidth } from '@/util/imageUtils';
import { MESSAGE_TYPES, VALID_SERVICE_WORKER_ENVIRONMENT, sendMessageToSW } from '@/util/swUtils';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useProductImageCarousel = props => {
  const { images, type, imageWidth, setCurrentIndex } = props;
  const [carouselState, carouselApi] = useCarousel(images);
  const { activeItemIndex, sortedImages } = carouselState;
  const { handlePrevious, handleNext, setActiveItemIndex } = carouselApi;

  const [currentProductImageIndex, setCurrentProductImageIndex] = useState(0);

  const [mobileVideoPlaying, setMobileVideoPlaying] = useState(false);

  const handleThumbnailClick = useCallback(
    index => {
      setActiveItemIndex(index);
    },
    [setActiveItemIndex],
  );

  // Whenever the incoming images changes reset the active item to the first.
  useEffect(() => {
    setActiveItemIndex(0);
  }, [images, setActiveItemIndex]);

  useEffect(() => {
    setCurrentIndex && setCurrentIndex(activeItemIndex);
  }, [activeItemIndex, setCurrentIndex]);

  useEffect(() => {
    if (VALID_SERVICE_WORKER_ENVIRONMENT) {
      const urls = images.map(
        ({ file }) => new URL(generateUrlFromContainerWidth(file, imageWidth, type), location.origin).href,
      );

      sendMessageToSW(MESSAGE_TYPES.PREFETCH_IMAGES, {
        urls,
      }).catch(err => {
        console.error('Unable to send PREFETCH_IMAGES message to SW', err);
      });
    }
  }, [images, imageWidth, type]);

  const currentImage = useMemo(() => {
    return sortedImages[activeItemIndex] || {};
  }, [sortedImages, activeItemIndex]);

  const altText = currentImage.label || 'image-product';

  return {
    currentImage,
    activeItemIndex,
    altText,
    handleNext,
    handlePrevious,
    handleThumbnailClick,
    sortedImages,
    currentProductImageIndex,
    setCurrentProductImageIndex,
    mobileVideoPlaying,
    setMobileVideoPlaying,
  };
};
